import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

class ServiceHeader extends Component {
  render() {
    return (
      <div className="service-header">
        <Link to={this.props.link}>{this.props.title}</Link>
      </div>
    );
  }
}

ServiceHeader.defaultProps = {
  link: '/',
  title: 'Link'
}

export default ServiceHeader;
